export default {
  drawer: null,
  color: "white",
};
